import React from "react";
import { motion } from "framer-motion";
import {
  Home,
  Sparkles,
  Building2,
  Briefcase,
  Truck,
  HardHat,
  ArrowUpRight,
} from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const ICONS = {
  regular: Home,
  deep: Sparkles,
  apartment: Building2,
  office: Briefcase,
  move_in_out: Truck,
  post_construction: HardHat,
};

export default function Services() {
  const { t } = useI18n();
  const items = t.services.items;

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl mb-16">
          <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#FF1F87]">
            {t.services.eyebrow}
          </span>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
            {t.services.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-zinc-400 max-w-2xl">
            {t.services.sub}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {items.map((s, idx) => {
            const Icon = ICONS[s.key] || Home;
            return (
              <motion.a
                key={s.key}
                href="#book"
                data-testid={`service-card-${s.key}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.55, delay: idx * 0.08 }}
                className="group relative bg-[#0A0A0A] border border-white/10 hover:border-[#EC008C]/60 rounded-3xl p-7 lg:p-8 flex flex-col h-full transition-all hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(236,0,140,0.4)]"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 rounded-2xl bg-[#EC008C]/15 border border-[#EC008C]/30 flex items-center justify-center group-hover:bg-[#EC008C] transition-colors">
                    <Icon className="w-5 h-5 text-[#FF66B3] group-hover:text-white transition-colors" />
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-zinc-500 group-hover:text-[#FF1F87] transition-all group-hover:rotate-12" />
                </div>

                <h3 className="font-display text-2xl font-bold tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{s.desc}</p>

                <ul className="mt-5 space-y-1.5">
                  {s.features.map((f) => (
                    <li key={f} className="text-xs text-zinc-300 flex items-center gap-2">
                      <span className="w-1 h-1 rounded-full bg-[#FF1F87]" />
                      {f}
                    </li>
                  ))}
                </ul>

                <div className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between">
                  <div className="font-display text-xl font-black pink-text">{s.price}</div>
                  <span className="text-xs font-semibold text-white group-hover:text-[#FF1F87] transition-colors">
                    {t.services.cta} →
                  </span>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
